<template>
  <modal
    :name="modalName"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed" :active-tab="activeTab">
          <CTab title="1. Informações Básicas">
            <!-- Informações Básicas -->
            <CCard class="mb-3">
              <CCardHeader class="section-header">
                <fa-icon icon="info-circle" class="mr-2" />
                <strong>Informações Básicas</strong>
              </CCardHeader>
              <CCardBody>
                <div class="xrow">
                  <div class="col-1-1">
                    <div class="form-group">
                      <label>
                        <fa-icon icon="tag" class="mr-1" />
                        Nome da Campanha
                      </label>
                      <input
                        class="form-control"
                        maxlength="250"
                        v-model="itemData.nome"
                        placeholder="Digite o nome da campanha"
                      />
                      <div class="message">
                        {{ validation.firstError("itemData.nome") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="xrow">
                  <div class="col-1-3">
                    <div class="form-group">
                      <label>
                        <fa-icon icon="calendar" class="mr-1" />
                        Data de Início
                      </label>
                      <datetime
                        input-class="form-control"
                        type="datetime"
                        v-model="itemData.dataInicio"
                        :max-datetime="itemData.dataFim"
                        :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                        value-zone="local"
                        placeholder="Selecione a data inicial"
                      />
                      <div class="message">
                        {{ validation.firstError("itemData.dataInicio") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-1-3">
                    <div class="form-group">
                      <label>
                        <fa-icon icon="calendar-check" class="mr-1" />
                        Data de Término
                      </label>
                      <datetime
                        :disabled="itemData.dataInicio === null"
                        input-class="form-control"
                        type="datetime"
                        :min-datetime="itemData.dataInicio"
                        v-model="itemData.dataFim"
                        :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                        value-zone="local"
                        placeholder="Selecione a data final"
                      />
                      <div class="message">
                        {{ validation.firstError("itemData.dataFim") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-1-3">
                    <div class="form-group">
                      <label>
                        <fa-icon icon="file-invoice" class="mr-1" />
                        Tipo de Apuração
                      </label>
                      <select class="form-control" v-model="itemData.tipoApuracao">
                        <option value="P">Pedido</option>
                        <option value="N">Nota Fiscal</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="xrow">
                  <div class="col-1-1">
                    <div class="form-group">
                      <label>
                        <fa-icon icon="list" class="mr-1" />
                        Tipo de Campanha
                      </label>
                      <select
                        class="form-control"
                        v-model="itemData.tipoCampanha"
                        :disabled="
                          (itemData.tipoCampanha === 'D' &&
                            itemData.dimensoes &&
                            itemData.dimensoes.length > 0) ||
                          (itemData.tipoCampanha === 'M' &&
                            itemData.mix &&
                            itemData.mix.length > 0)
                        "
                      >
                        <option value="D">Dimensão</option>
                        <option value="M">Mix de Produtos</option>
                      </select>
                      <small class="form-text text-muted" v-if="itemData.dimensoes && itemData.dimensoes.length > 0 || itemData.mix && itemData.mix.length > 0">
                        Não é possível alterar o tipo após adicionar dimensões ou produtos
                      </small>
                    </div>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </CTab>

          <CTab title="2. Dimensões / Mix">
            <!-- Dimensões -->
            <CCard class="mb-3" v-if="itemData.tipoCampanha === 'D'">
              <CCardHeader class="section-header">
                <fa-icon icon="layer-group" class="mr-2" />
                <strong>Dimensões da Campanha</strong>
                <small class="validation-error ml-2">{{
                  validation.firstError("itemData.dimensoes")
                }}</small>
              </CCardHeader>
              <CCardBody>
                <!-- Lista de Dimensões -->
                <div v-if="dimensoesValidas && dimensoesValidas.length > 0" class="mb-3">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th width="60">#</th>
                          <th>Descrição</th>
                          <th width="80" class="text-center">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(dim, index) in dimensoesValidas" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <fa-icon icon="layer-group" class="text-muted mr-2" />
                            {{ getDescricaoDimensao(dim) }}
                          </td>
                          <td class="text-center">
                            <CButton
                              color="danger"
                              size="sm"
                              @click="() => removeDimensao(index)"
                              v-c-tooltip="'Remover dimensão'"
                            >
                              <fa-icon icon="trash-alt" />
                            </CButton>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Empty State -->
                <div v-else class="empty-state-small">
                  <fa-icon icon="layer-group" size="2x" class="text-muted mb-2" />
                  <p class="text-muted mb-0">Nenhuma dimensão adicionada</p>
                </div>

                <hr class="my-3" />

                <!-- Adicionar Dimensão -->
                <div>
                  <label class="section-label">
                    <fa-icon icon="plus-circle" class="mr-1" />
                    Adicionar Nova Dimensão
                  </label>
                  <div class="xrow">
                    <div class="col-1-2">
                      <div class="form-group">
                        <label>Coluna</label>
                        <select
                          class="form-control"
                          v-model="dimensaoForm.indice"
                          v-on:change="changeDimensao"
                        >
                          <option value="-1" v-if="!dimensao.dimensao">
                            Selecione uma coluna
                          </option>
                          <option v-for="(dim, index) in dimensoes" :key="index" :value="index">
                            {{ dim.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-1-2">
                      <div class="form-group">
                        <label>Valor</label>
                        <div class="input-group">
                          <select class="form-control" v-model="dimensao.dimensao">
                            <option
                              v-for="(itemData, index) in getDimensoesItens"
                              :key="index"
                              :value="itemData.id"
                              :selected="index === 0"
                            >
                              {{ itemData.desc }}
                            </option>
                          </select>
                          <CButton
                            color="primary"
                            class="input-group-addon-right"
                            :disabled="dimensaoForm.indice < 0"
                            @click="addDimensao"
                          >
                            <fa-icon icon="plus" />
                          </CButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CCardBody>
            </CCard>

            <CCard class="mb-3" v-else>
              <CCardHeader class="section-header">
                <fa-icon icon="box" class="mr-2" />
                <strong>Mix de Produtos</strong>
                <small class="validation-error ml-2">{{
                  validation.firstError("itemData.mix")
                }}</small>
              </CCardHeader>
              <CCardBody>
                <Multiselectable
                  :items="produtos"
                  :campanha="itemData"
                  :itemsSelected="itemData.mix"
                  itemKey="id"
                  :select-callback="addProdutoMix"
                  :deselect-callback="removeProdutoMix"
                  :loadProdutos="loadProdutos"
                />
              </CCardBody>
            </CCard>
          </CTab>

          <CTab title="3. Operadores e Metas">
            <!-- Operadores e Metas -->
            <CCard class="mb-3">
              <CCardHeader class="section-header">
                <fa-icon icon="users" class="mr-2" />
                <strong>Operadores e Metas</strong>
                <small class="validation-error ml-2">{{
                  validation.firstError("itemData.metasOperadores")
                }}</small>
              </CCardHeader>
              <CCardBody>
                <!-- Lista de Operadores -->
                <div v-if="metasOperadoresValidos && metasOperadoresValidos.length > 0" class="mb-3">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th width="80">Código</th>
                          <th>Nome</th>
                          <th width="120">Positivação</th>
                          <th width="140">% Mix</th>
                          <th width="140">Valor Meta</th>
                          <th width="80" class="text-center">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(operador, index) in metasOperadoresValidos" :key="index">
                          <td>
                            <CBadge color="primary">{{ operador.codOp }}</CBadge>
                          </td>
                          <td>
                            <fa-icon icon="user" class="text-muted mr-2" />
                            {{ getNomeOperador(operador.codOp) }}
                          </td>
                          <td>{{ toPercent(operador.positivacao) }}</td>
                          <td>{{ toPercent(operador.percMix) }}</td>
                          <td>
                            <strong class="text-success">{{ toMonetary(operador.vlMeta) }}</strong>
                          </td>
                          <td class="text-center">
                            <CButton
                              color="danger"
                              size="sm"
                              @click="() => removeOperador(index)"
                              v-c-tooltip="'Remover operador'"
                            >
                              <fa-icon icon="trash-alt" />
                            </CButton>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="table-total">
                          <td colspan="4" class="text-right font-weight-bold">TOTAL:</td>
                          <td colspan="2" class="font-weight-bold text-success">
                            {{ getMetaTotal }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- Empty State -->
                <div v-else class="empty-state-small">
                  <fa-icon icon="users" size="2x" class="text-muted mb-2" />
                  <p class="text-muted mb-0">Nenhum operador adicionado</p>
                  <small class="text-muted">Adicione operadores abaixo para definir as metas</small>
                </div>

                <hr class="my-3" />
            <div class="xrow">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h2 class="mb-0">ADICIONAR OPERADOR:</h2>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="modoLote"
                    v-model="modoLote"
                  />
                  <label class="custom-control-label" for="modoLote">
                    <fa-icon icon="users" class="mr-1" />
                    Adicionar em Lote
                  </label>
                </div>
              </div>

              <!-- Modo Individual -->
              <div v-if="!modoLote" class="row">
                <div class="col-1-4">
                  <div class="form-group">
                    <label for>Operador</label>
                    <select class="form-control" v-model="metaOperador.codOp">
                      <option value>Selecione</option>
                      <option v-for="op in operadoresFiltrados" :key="op.codOp" :value="op.codOp">
                        {{ op.nome }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-1-4">
                  <div class="form-group">
                    <label for>Positivação</label>
                    <the-mask
                      :mask="['#%', '##%']"
                      class="form-control"
                      type="text"
                      v-model="metaOperador.positivacao"
                    />
                  </div>
                </div>
                <div class="col-1-4">
                  <div class="form-group">
                    <label for>Percentual de Mix</label>
                    <the-mask
                      :mask="['#%', '##%']"
                      class="form-control"
                      type="text"
                      v-model="metaOperador.percMix"
                    />
                  </div>
                </div>
                <div class="col-1-4">
                  <div class="form-group">
                    <label for>Valor Meta:</label>
                    <div class="input-group">
                      <money
                        class="form-control"
                        v-model="metaOperador.vlMeta"
                        v-bind="monetary"
                      />
                      <button
                        class="button button-primary input-group-addon-right"
                        :disabled="!metaOperador.codOp"
                        title="Adicionar"
                        v-on:click="addOperador"
                      >
                        +
                      </button>
                    </div>
                    <div class="message">
                      {{ validation.firstError("itemData.vlMeta") }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modo Lote -->
              <div v-else>
                <div class="bulk-operator-section">
                  <div class="row">
                    <div class="col-1-3">
                      <div class="form-group">
                        <label>
                          <fa-icon icon="bullseye" class="mr-1" />
                          Positivação
                        </label>
                        <the-mask
                          :mask="['#%', '##%']"
                          class="form-control"
                          type="text"
                          v-model="metaLote.positivacao"
                        />
                      </div>
                    </div>
                    <div class="col-1-3">
                      <div class="form-group">
                        <label>
                          <fa-icon icon="chart-pie" class="mr-1" />
                          Percentual de Mix
                        </label>
                        <the-mask
                          :mask="['#%', '##%']"
                          class="form-control"
                          type="text"
                          v-model="metaLote.percMix"
                        />
                      </div>
                    </div>
                    <div class="col-1-3">
                      <div class="form-group">
                        <label>
                          <fa-icon icon="dollar-sign" class="mr-1" />
                          Valor Meta
                        </label>
                        <money
                          class="form-control"
                          v-model="metaLote.vlMeta"
                          v-bind="monetary"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="operadores-selection">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <label class="font-weight-bold mb-0">
                        <fa-icon icon="users" class="mr-1" />
                        Selecionar Operadores ({{ operadoresSelecionados.length }} selecionados)
                      </label>
                      <CButton
                        v-if="operadoresDisponiveisPorBusca.length > 0"
                        color="secondary"
                        size="sm"
                        @click="toggleTodosOperadores"
                      >
                        <fa-icon :icon="todosOperadoresSelecionados ? 'check-square' : 'square'" class="mr-1" />
                        {{ todosOperadoresSelecionados ? 'Desmarcar' : 'Marcar' }} Todos
                      </CButton>
                    </div>

                    <!-- Filtro de Busca -->
                    <div class="form-group mb-2">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtroOperadores"
                          placeholder="Buscar por nome ou código..."
                        />
                        <CButton
                          v-if="filtroOperadores"
                          color="secondary"
                          size="sm"
                          @click="filtroOperadores = ''"
                          class="input-group-addon-right"
                        >
                          <fa-icon icon="times" />
                        </CButton>
                      </div>
                    </div>

                    <div class="operadores-grid">
                      <div
                        v-for="op in operadoresDisponiveisPorBusca"
                        :key="getOperadorId(op)"
                        class="operador-item"
                        :class="{ 'operador-inelegivel': !operadorElegivel(op) }"
                      >
                        <label class="custom-checkbox-label" :class="{ 'disabled': !operadorElegivel(op) }">
                          <input
                            type="checkbox"
                            :value="getOperadorId(op)"
                            v-model="operadoresSelecionados"
                            :disabled="!operadorElegivel(op)"
                          />
                          <span class="checkbox-custom"></span>
                          <span class="operador-info">
                            <span class="operador-codigo" :class="{ 'codigo-ausente': !operadorElegivel(op) }">
                              {{ operadorElegivel(op) ? op.codOp : 'Sem código de vendedor preenchido' }}
                            </span>
                            <span class="operador-nome">{{ op.nome }}</span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div v-if="operadoresFiltrados.length === 0" class="text-center text-muted py-3">
                      Todos os operadores já foram adicionados
                    </div>
                    <div v-else-if="operadoresDisponiveisPorBusca.length === 0" class="text-center text-muted py-3">
                      <fa-icon icon="search" class="mr-1" />
                      Nenhum operador encontrado com "{{ filtroOperadores }}"
                    </div>
                  </div>

                  <div class="text-right mt-3">
                    <CButton
                      color="secondary"
                      @click="limparSelecaoLote"
                      :disabled="operadoresSelecionados.length === 0"
                      class="mr-2"
                    >
                      <fa-icon icon="times" class="mr-1" />
                      Limpar Seleção
                    </CButton>
                    <CButton
                      color="primary"
                      @click="addOperadoresLote"
                      :disabled="operadoresSelecionados.length === 0"
                    >
                      <fa-icon icon="plus-circle" class="mr-1" />
                      Adicionar {{ operadoresSelecionados.length }} Operador(es)
                    </CButton>
                  </div>
                </div>
              </div>
            </div>
              </CCardBody>
            </CCard>
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">
        Cancelar
      </CButton>
      <CButton color="primary" :disabled="validation.hasError()" @click="handleSubmit">
        {{ isEdit ? "Alterar" : "Inserir" }}
      </CButton>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import CloseModal from "@/components/CloseModal.vue";
import Multiselectable from "./multiselectable";
import { toMonetary, toPercent } from "@/helpers/utils";
import _find from "lodash/find";
import _filter from "lodash/filter";
import _remove from "lodash/remove";
import _some from "lodash/some";
import _sumBy from "lodash/sumBy";
import { filtrarValidos } from "../../../../helpers/campanhas";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "Campo de preenchimento obrigatório",
    greaterThan: "Valor deve ser maior que {0}",
  },
});

export default {
  name: "CampanhaMetas",
  props: {
    item: Object,
    isEdit: Boolean,
    create: Function,
    update: Function,
    close: Function,
    initialItem: Function,
    initialDimensaoForm: Function,
    initialDimensao: Function,
    initialMetaOperador: Function,
    descSingular: String,
    dimensoes: Array,
    operadores: Array,
    produtos: Array,
    loadProdutos: Function,
  },
  data() {
    return {
      internalItem: this.initialItem(),
      dimensaoForm: this.initialDimensaoForm(),
      dimensao: this.initialDimensao(),
      metaOperador: this.initialMetaOperador(),
      activeTab: 0,
      modoLote: false,
      operadoresSelecionados: [],
      filtroOperadores: '',
      metaLote: {
        positivacao: "1",
        percMix: "1",
        vlMeta: "1",
      },
      monetary: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        masked: false,
      },
    };
  },
  watch: {
    item: {
      handler(newItem) {
        if (newItem) {
          this.internalItem = newItem;
        }
      },
      immediate: true,
      deep: true,
    },
    itemData: {
      handler(newItem) {
        this.$validate();
      },
      deep: true,
    },
    "itemData.tipoCampanha"(novaCampanha) {
      if (novaCampanha === "D") {
        this.validation.reset("itemData.mix");
      } else if (novaCampanha === "M") {
        this.validation.reset("itemData.dimensoes");
      }
      this.$validate();
    },
    "itemData.metasOperadores": {
      handler() {
        // Força a atualização da lista de operadores disponíveis
        // Isso garante que operadores removidos voltem para a lista
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  computed: {
    modalName() {
      return this.isEdit ? "campanhaEdit" : "campanhaCreate";
    },
    itemData() {
      return this.internalItem;
    },
    getMetaTotal() {
      return toMonetary(_sumBy(this.itemData.metasOperadores, "vlMeta"));
    },
    getDimensoesItens() {
      const dimensao = _find(
        this.dimensoes,
        (dim) => dim.coluna === this.dimensao.coluna
      );
      return dimensao ? dimensao.dimensoes : [];
    },
    operadoresFiltrados() {
      // Força a reatividade verificando explicitamente metasOperadores
      const metasOperadores = this.itemData.metasOperadores || [];

      return _filter(
        this.operadores,
        (operador) =>
          !_some(
            metasOperadores,
            (metaOperador) => metaOperador.codOp === operador.codOp
          )
      );
    },
    operadoresDisponiveisPorBusca() {
      if (!this.filtroOperadores) {
        return this.operadoresFiltrados;
      }
      const busca = this.filtroOperadores.toLowerCase();
      return _filter(this.operadoresFiltrados, (op) => {
        const nome = (op.nome || '').toLowerCase();
        const codigo = (op.codOp || '').toString().toLowerCase();
        return nome.includes(busca) || codigo.includes(busca);
      });
    },
    operadorElegivel() {
      // Retorna função para verificar se operador é elegível
      return (operador) => {
        return operador.codOp && operador.codOp.toString().trim() !== '';
      };
    },
    todosOperadoresSelecionados() {
      const elegiveis = _filter(this.operadoresDisponiveisPorBusca, this.operadorElegivel);
      if (elegiveis.length === 0) return false;
      return elegiveis.every((op) =>
        this.operadoresSelecionados.includes(this.getOperadorId(op))
      );
    },
    metasOperadoresValidos() {
      const validos = filtrarValidos(
        this.itemData.metasOperadores,
        this.operadores,
        (metaOp, op) => +metaOp.codOp === +op.codOp
      );

      this.itemData.metasOperadores = validos;
      return validos;
    },
    dimensoesValidas() {
      const validas = filtrarValidos(
        this.itemData.dimensoes,
        this.dimensoes,
        (dim, col) => {
          const coluna = col.coluna;
          const descricao = _find(
            col.dimensoes,
            (dimensanId) => dimensanId.id === dim.dimensao
          );
          return coluna === dim.coluna && !!descricao?.desc;
        }
      );

      this.itemData.dimensoes = validas;
      return validas;
    },
  },
  validators: {
    "itemData.nome": (v) => Validator.value(v).required(),
    "itemData.metasOperadores": (v) => Validator.value(v).required(),
    "itemData.dataInicio": (v) => Validator.value(v).required(),
    "itemData.dataFim": (v) => Validator.value(v).required(),
    "itemData.dimensoes, itemData.tipoCampanha"(dimensoes, tipoCampanha) {
      if (tipoCampanha === "D") return Validator.value(dimensoes).required();
    },
    "itemData.mix, itemData.tipoCampanha"(mix, tipoCampanha) {
      if (tipoCampanha === "M") return Validator.value(mix).required();
    },
  },
  methods: {
    handleSubmit() {
      this.$validate().then((success) => {
        if (!success) return;

        if (this.isEdit) {
          this.update(this.itemData);
        } else {
          this.create(this.itemData);
          this.internalItem = initialItem();
        }

        Validator.reset();
      });
    },
    getNomeOperador(codOp) {
      const op = _find(this.operadores, (o) => +o.codOp === +codOp);
      return op?.nome || "—";
    },
    getDescricaoDimensao(dim) {
      const col = _find(this.dimensoes, (d) => d.coluna === dim.coluna);
      const desc = _find(col?.dimensoes, (d) => d.id === dim.dimensao);

      if (!col || !desc?.desc) {
        return null;
      }

      return `${col.label} = ${desc.desc}`;
    },
    changeDimensao() {
      this.dimensao = {
        coluna: this.dimensoes[this.dimensaoForm.indice].coluna,
        dimensao: this.dimensoes[this.dimensaoForm.indice].dimensoes[0].id,
      };
    },
    addOperador() {
      this.itemData.metasOperadores.push(this.metaOperador);
      this.metaOperador = {
        codOp: "",
        vlMeta: "1",
        positivacao: "1",
        percMix: "1",
      };
    },
    getOperadorId(operador) {
      // Usa índice do array de operadores original como ID único
      const index = this.operadores.indexOf(operador);
      return `op_${index}_${operador.codOp || 'sem_cod'}`;
    },
    getOperadorById(id) {
      // Extrai o índice do ID
      const match = id.match(/^op_(\d+)_/);
      if (match) {
        const index = parseInt(match[1]);
        return this.operadores[index];
      }
      return null;
    },
    toggleTodosOperadores() {
      if (this.todosOperadoresSelecionados) {
        // Desmarcar todos os elegíveis e visíveis
        const elegiveis = _filter(this.operadoresDisponiveisPorBusca, this.operadorElegivel);
        elegiveis.forEach((op) => {
          const id = this.getOperadorId(op);
          const index = this.operadoresSelecionados.indexOf(id);
          if (index > -1) {
            this.operadoresSelecionados.splice(index, 1);
          }
        });
      } else {
        // Marcar todos os elegíveis e visíveis
        const elegiveis = _filter(this.operadoresDisponiveisPorBusca, this.operadorElegivel);
        elegiveis.forEach((op) => {
          const id = this.getOperadorId(op);
          if (!this.operadoresSelecionados.includes(id)) {
            this.operadoresSelecionados.push(id);
          }
        });
      }
    },
    addOperadoresLote() {
      if (this.operadoresSelecionados.length === 0) {
        return;
      }

      const quantidadeSelecionados = this.operadoresSelecionados.length;
      let quantidadeAdicionados = 0;

      this.operadoresSelecionados.forEach((opId) => {
        const operador = this.getOperadorById(opId);
        if (operador && this.operadorElegivel(operador)) {
          this.itemData.metasOperadores.push({
            codOp: operador.codOp,
            positivacao: this.metaLote.positivacao,
            percMix: this.metaLote.percMix,
            vlMeta: this.metaLote.vlMeta,
          });
          quantidadeAdicionados++;
        }
      });

      this.limparSelecaoLote();

      this.$swal({
        title: 'Sucesso!',
        text: `${quantidadeAdicionados} operador(es) adicionado(s)`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
    },
    limparSelecaoLote() {
      this.operadoresSelecionados = [];
      this.filtroOperadores = '';
    },
    removeOperador(i) {
      this.itemData.metasOperadores.splice(i, 1);
    },
    addDimensao() {
      this.itemData.dimensoes.push(this.dimensao);
      this.dimensao = { coluna: "", dimensao: "" };
      this.dimensaoForm = { indice: -1 };
    },
    removeDimensao(i) {
      this.itemData.dimensoes.splice(i, 1);
    },
    addProdutoMix(prod) {
      this.itemData.mix.push(prod);
    },
    removeProdutoMix(id) {
      _remove(this.itemData.mix, (p) => +p === +id);
    },
    toMonetary,
    toPercent,
  },
  components: {
    Multiselectable,
    CloseModal,
  },
};
</script>

<style scoped>
/* Section Headers */
.section-header {
  background: linear-gradient(135deg, #3a3e81 0%, #2298a3 100%);
  color: white;
  font-weight: 600;
  padding: 0.75rem 1.25rem;
  border-bottom: none;
}

.section-header .svg-inline--fa {
  opacity: 0.9;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  display: block;
}

/* Modal Footer */
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}

/* Empty States */
.empty-state-small {
  text-align: center;
  padding: 2rem 1rem;
  background: #f8f9fa;
  border-radius: 0.375rem;
  border: 2px dashed #dee2e6;
}

.empty-state-small .svg-inline--fa {
  color: #cbd5e0;
}

/* Table Improvements */
.table-total {
  background-color: #f8f9fa;
  border-top: 2px solid #dee2e6;
}

.table tbody tr:hover {
  background-color: rgba(58, 62, 129, 0.02);
}

/* Form Helpers */
.form-text {
  font-size: 0.8125rem;
}

.validation-error {
  color: #dc3545;
  font-size: 0.875rem;
  font-weight: normal;
}

/* Utility Classes */
.my-3 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/* Bulk Operator Section */
.bulk-operator-section {
  background: linear-gradient(135deg, rgba(58, 62, 129, 0.03) 0%, rgba(34, 152, 163, 0.03) 100%);
  padding: 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
}

/* Search Input */
.input-group .input-group-addon-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* Operador Inelegível */
.operador-inelegivel {
  background: linear-gradient(135deg, #fee 0%, #fdd 100%);
  border-color: #fcc;
  opacity: 0.85;
}

.operador-inelegivel:hover {
  border-color: #fbb;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.15);
}

.operador-inelegivel .custom-checkbox-label {
  cursor: not-allowed;
}

.operador-inelegivel .checkbox-custom {
  border-color: #dc3545;
  background-color: #f8d7da;
}

.operador-codigo.codigo-ausente {
  color: #dc3545;
  font-size: 0.75rem;
  font-style: italic;
  font-weight: 500;
}

.custom-checkbox-label.disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.operadores-selection {
  margin-top: 1.5rem;
}

.operadores-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.75rem;
  padding: 0.5rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.operador-item {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
}

.operador-item:hover {
  border-color: #3a3e81;
  box-shadow: 0 2px 4px rgba(58, 62, 129, 0.1);
}

.custom-checkbox-label {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  margin: 0;
  cursor: pointer;
  user-select: none;
}

.custom-checkbox-label input[type="checkbox"] {
  display: none;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: 2px solid #cbd5e0;
  border-radius: 0.25rem;
  margin-right: 0.75rem;
  position: relative;
  transition: all 0.2s ease;
}

.custom-checkbox-label input[type="checkbox"]:checked + .checkbox-custom {
  background-color: #3a3e81;
  border-color: #3a3e81;
}

.custom-checkbox-label input[type="checkbox"]:checked + .checkbox-custom::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.operador-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.operador-codigo {
  font-weight: 600;
  color: #3a3e81;
  font-size: 0.875rem;
}

.operador-nome {
  color: #718096;
  font-size: 0.8125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-control-label {
  cursor: pointer;
  font-weight: 600;
  color: #3a3e81;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mt-3 {
  margin-top: 1rem;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #718096;
}

.py-3 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.font-weight-bold {
  font-weight: 600;
}

/* Scrollbar styling */
.operadores-grid::-webkit-scrollbar {
  width: 8px;
}

.operadores-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.operadores-grid::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

.operadores-grid::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}
</style>
